import { IonButton, IonIcon, IonSkeletonText } from '@ionic/react'
import { chevronForwardOutline } from 'ionicons/icons'
import React from 'react'
import styled from 'styled-components'
import { TextStyle } from '../../../components'

export const ProductInfoLoading: React.FC = () => {
  return (
    <>
      <ProductContainer>
        <ProductInfoContainer>
          <IonSkeletonText animated={true} className="img" />
          <div className="product-info">
            <IonSkeletonText animated={true} className="artist" />
            <IonSkeletonText animated={true} className="title" />
          </div>
        </ProductInfoContainer>
        <DetailLinkContainer>
          <IonButton size="small" fill="clear" color="medium">
            <TextStyle type={'r_13'}>작품 상세보기</TextStyle>
            <IonIcon icon={chevronForwardOutline} />
          </IonButton>
        </DetailLinkContainer>
      </ProductContainer>
    </>
  )
}

const ProductContainer = styled.div`
  padding: 22px 20px;
`

const ProductInfoContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;
  .img {
    border-radius: 7px;
    width: 100%;
    height: 48px;
    margin-bottom: 5px;
  }
  .product-info {
    grid-area: 1 / 2 / 2 / 6;
    display: flex;
    flex-direction: column;
  }
`

const DetailLinkContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
  ion-button {
    --padding-end: 0;
    padding: 0;
    margin: 0;
  }
`
